// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2FOXQ","description":"PatientConsentPreview_description__AhI0X"};